import { getErrorMsg, logger } from 'lib/logger';
import { IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { initProducts, initProductsForAnonymous } from 'reactApp/modules/products/products.module';
import {
    loadQuotaLandingFailure,
    loadQuotaLandingRequest,
    loadQuotaLandingSuccess,
} from 'reactApp/modules/quotaLanding/quotaLanding.module';
import { routeChangeSuccess } from 'reactApp/modules/router/router.module';
import { getQuotaLandingStorage } from 'reactApp/modules/router/router.selectors';
import { loadSocialUser } from 'reactApp/modules/socialUser/actions/loadSocialUser.action';
import { handleSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.saga';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { loadQuota } from 'reactApp/modules/userQuota/userQuota.saga';
import { all, call, cancel, put, select, takeEvery } from 'redux-saga/effects';

function* startLandingQuota(action: ReturnType<typeof loadQuotaLandingRequest>) {
    const { checkSocialUser } = action.payload;

    const storage = getQuotaLandingStorage();

    yield put(
        routeChangeSuccess({
            id: ROOT_FOLDER_ID,
            storage,
            params: {},
            __isFolder: true,
            url: '',
            __parent: '',
        })
    );

    const isAnonymous = yield select(UserSelectors.isAnonymous);

    if (isAnonymous) {
        yield put(initProductsForAnonymous());
        yield put(loadQuotaLandingSuccess());
        return;
    }

    try {
        if (IS_SOCIAL_USER && checkSocialUser) {
            yield put(loadSocialUser());
            yield call(loadQuota);
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            yield all([loadQuota(), handleSubscriptionsRequest({ skipFutureReq: true })]);
        }

        yield put(initProducts());

        yield put(loadQuotaLandingSuccess());
    } catch (error) {
        logger.error(getErrorMsg(error), error);
        yield put(loadQuotaLandingFailure());
        yield cancel();
    }
}

export function* watchQuotaLanding() {
    yield takeEvery(loadQuotaLandingRequest.toString(), startLandingQuota);
}
